export default {
  search: 'Search',
  rolesForUser: 'Roles for user:',
  save: 'Save',
  warning: 'Warning',
  cannotBeUndone: 'This action cannot be undone. Are you sure?',
  abort: 'Abort',
  confirm: 'Confirm',
  processing: 'Processing...',
  close: 'Close',
  name: 'Name',
  lastname: 'Lastname',
  email: 'E-mail',
  roles: 'Roles',
  role: 'Role',
  description: 'Description',
  modelAccessManager: 'Can manage model access for other users',
  ekrmManager: 'Can manage Expert Knowledge Reference Models (EKRM)',
  dataUploader: 'Can upload data for Model Setup',
  onlyShowModelReport: 'Only show Model Report in navigation',
  externalUser: 'External user: can only see plans they created or were given access to. Limited to Model Report (without AUC/Correlation metrics) and Media Planner sections.',
  diyModeler: 'Can use the Automatic Models (DIY Modeler) feature',
  rolesUpdated: 'Roles updated successfully',
  failedToUpdateRoles: 'Failed to update roles. Please try again.',
  errorUpdatingRoles: 'An error occurred while updating roles:'
}
